import type { DataType } from './common';
import type { Action } from './roles';
import type { User } from './users';
import type { APIListResponse } from 'vince-core/types/api';
import { JsonSchemaType } from 'vince-core/types/formats';

export interface SearchPayload {
    tableName: string;
    body: {
        query: object;
        size: number;
    };
}

export interface ColumnConfig {
    columnOrder?: number; // TODO: Remove this field, displayOrder from table should be used instead
    aliasName: string;
    dataType: DataType;
    linkText?: string;
    link?: string;
}

export type ColumnsConfig = {
    [key: string]: ColumnConfig;
};

export enum UpdateType {
    UPSERT = 'UPSERT',
    APPEND = 'APPEND',
    REPLACE = 'REPLACE',

}

export enum PropertyFormat {
    ISO_DATE_TIME = 'iso-date-time',
    M3_DATE = 'm3-date',
    COMPUTE_EXPRESSION = 'compute-expression',
    EMAIL = 'email',
    UUID = 'uuid',
    IPV4 = 'ipv4',
}

export interface SchemaPropertyItems {
    type: JsonSchemaType;
}

export interface SchemaProperty {
    type: JsonSchemaType;
    title?: string; // Column Display name
    enum?: string[]; // Used with advanced configuration and allowed values set
    format?: PropertyFormat;
    default?: string; // Used when format is compute-expression
    items?: SchemaPropertyItems; // Item type, required when type is 'array'
  }

export interface Schema {
    properties: Record<string, SchemaProperty>;
    type: JsonSchemaType.OBJECT;
    required?: string[];
}


export interface Table {
    columnConfig: ColumnsConfig;
    entity: string;
    primaryKeys: string[];
    displayOrder?: string[];
    rowCount: number;
    shardMax: number;
    newTimestamp?: string;
    newRowCount?: number;
    tableAlias: string;
    tableName: string;
    toBeDeleted?: boolean;
    description?: string;
    tenantId?: string;
    timestamp: string;
    updateType: UpdateType
    modified?: string;
    modifiedBy?: string;
    created?: string;
    createdBy?: string;
    schema?: Schema;
    enforceSchema?: boolean;
}

export interface TableListResponse {
    count: number;
    items: Table[];
}

export interface TableRow {
    __id?: string;
    [key: string]: unknown;
}


export type TableDataSearchResponse = APIListResponse<TableRow>;

export interface OpenSearchListResponse {
    hits: {
        hits: {
            _id: string
            _source: TableRow
        }
    }
}

export interface TableField {
    field: string;
    idxType: string;
    aliasName: string;
    dataType: DataType;
    schemaType?: string;
    schemaFormat?: string;
}

export interface TableFieldsResponse {
    count: number;
    items: TableField[];
}

export interface ExpandedTable extends Table {
    filterText?: string;
    createdByUser?: User | null;
    modifiedByUser?: User | null;
}

export interface WorkflowLinkedTable extends ExpandedTable {
    workflowName?: string;
    workflowId?: string;
}

export interface ExpandedSchemaProperty extends SchemaProperty {
    id: string;
    name: string;
    selectedType?: { type: JsonSchemaType; format?: PropertyFormat; items?: SchemaPropertyItems }
    primaryKey: boolean;
    nameError?: string | null;
    titleError?: string | null;
    nameUpdatable?: boolean;
}

export interface MenuOptions {
    icon: string;
    labelKey: string;
    command: (table: WorkflowLinkedTable) => void;
    requiredAccess: Action;
}
